import { action } from 'app/actions';

export const CHANGE_PASSWORD = 'login/CHANGE_PASSWORD';

export const changePassword = payload => action(CHANGE_PASSWORD, {payload});
